export function parseProductImageUrls(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string") return [];

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function getProductImageUrls(product) {
  const urls = [
    ...parseProductImageUrls(product?.custitem_product_images),
    product?.file_url,
  ];

  return urls.reduce((uniqueUrls, url) => {
    if (typeof url !== "string") return uniqueUrls;
    const trimmed = url.trim();
    if (!trimmed || uniqueUrls.includes(trimmed)) return uniqueUrls;
    uniqueUrls.push(trimmed);
    return uniqueUrls;
  }, []);
}

export function getPrimaryProductImage(product) {
  return getProductImageUrls(product)[0] || product?.file_url;
}
